import { render, staticRenderFns } from "./InlinePromise.vue?vue&type=template&id=120495a5&scoped=true"
import script from "./InlinePromise.vue?vue&type=script&lang=ts"
export * from "./InlinePromise.vue?vue&type=script&lang=ts"
import style0 from "./InlinePromise.vue?vue&type=style&index=0&id=120495a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120495a5",
  null
  
)

export default component.exports